module.exports = __webpack_public_path__ + "static/media/jmi_logo.e5bfe07c.jpeg";